import Vue from "vue";

const getDefaultState = () => {
  return {
    Themes: [],
    //field: "name",
    //whereField: "role",
    //whereValue: "superviseur",
    collection: "themes",
  };
};
const state = getDefaultState();

const mutations = {
  SET_LISTE(state, payload) {
    state.Themes = payload;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  async GetAll({ commit, dispatch }) {
    // start requête
    commit("SET_LISTE", []);

    commit("Loading/START_BUSY_STATE", "Themes GetAll", { root: true });

    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection(this.state.Themes.collection)
      .get()
      .then(
        (snapshot) => {
          if (snapshot.metadata.hasPendingWrites) {
            console.log("il en reste");
            commit("Pending/START_PENDING_STATE", null, { root: true });
          } else {
            console.log("tout est synchronisé Dans Themes GetAll");
            commit("Pending/END_PENDING_STATE", null, { root: true });
          }
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            console.log("No Data Available");
            return false;
          } else {
            commit("SET_LISTE", elems);
            commit("Loading/END_BUSY_STATE", "Themes.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit("Loading/END_BUSY_STATE", "Themes.store.js", {
            root: true,
          });
        }
      );
  },
};

const getters = {
  Themes: (state) => {
    return state.Themes;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
